import m from "./ghl-ui.es1436.js";
import a from "./ghl-ui.es1437.js";
import i from "./ghl-ui.es1398.js";
function d(t, r) {
  i(2, arguments);
  var e = a(t).getTime(), o = m(r);
  return new Date(e + o);
}
export {
  d as default
};
